import { useSQDCEventArchiveMutation } from "@/graphql";
import { triggerHalloweenArchiveSpider } from "@/functions/halloweenSpider";

/** Keep the decoration behind the real mutation result, never its optimistic cache update. */
export function useSQDCEventArchiveWithSpider(
  options?: Parameters<typeof useSQDCEventArchiveMutation>[0],
) {
  const mutation = useSQDCEventArchiveMutation(options);
  mutation.onDone(({ data, errors }) => {
    if (data?.SQDCEventArchive?.deletedAt != null && !errors?.length) {
      triggerHalloweenArchiveSpider(data.SQDCEventArchive);
    }
  });
  return mutation;
}
